export default __webpack_public_path__ + "static/media/maame-grey.9bcbedc5.png";